import { TextField } from '@symphony-ui/uitoolkit-components';
import Yield from '../../../../../../models/data/Yield';
import * as React from 'react';
const YieldEditor = ({ value, onChange }) => {
    const [text, setText] = React.useState(value?.value?.toString() ?? '');
    const onChangeValue = React.useCallback((event) => {
        const newValue = Number.parseFloat(event.target.value);
        setText(event.target.value);
        const newYield = new Yield({ value: newValue });
        onChange({ target: { value: newYield } });
    }, [onChange]);
    return (React.createElement(TextField, { value: text, onChange: onChangeValue }));
};
export default YieldEditor;
